import { createReducer, updateItemInArray, updateObject } from 'helpers/ReducerUtil'
import {
  ADD_VALUE,
  UPDATE_VALUE,
  REMOVE_VALUE
} from './constants'
import { DETAILS } from 'components/form/powerMonitorIc/constant'
import _ from 'lodash'

const addValue = (values, {index}) => {
  return [...values, {type: '', vendor: '', partNumber: '', details: ''}]
}

const removeValue = (values, {index}) => {
  let currentIndex = 0
  let isValid = true
  return values.filter(row => {
    isValid = (currentIndex!==index)
    currentIndex+=1
    return isValid
  })
}

const updateValue = (values, {index, type, value, inputType}) => {
  let currIndex = 0
  return values.map(row => {
      if (index === currIndex) row[inputType] = value['value'] || value
    currIndex += 1 
    return row
  })
}

const powerMonitorIcReducer = createReducer([], {
  [ADD_VALUE]: addValue,
  [UPDATE_VALUE]: updateValue,
  [REMOVE_VALUE]: removeValue
})

export default powerMonitorIcReducer
